import Vue from 'vue';
import Component from 'vue-class-component';
import Router from 'vue-router';
import admin from '@/router/admin';
import entities from '@/router/entities';
import pages from '@/router/pages';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

const MainLayout = () => import('@/core/layouts/main-layout.vue');
const Home = () => import('@/core/home/home.vue');
const Error = () => import('@/core/error/error.vue');
const LoadingLoginPage = () => import('@/core/layouts/loading-login/loading-login-page.vue');
const RegionComponent = () => import('@/entities/hr/region/region.vue');
const FinderArchitecture = () => import('@/entities/finder-architecture/finder-architecture.vue');
const HrStructureComponent = () => import('@/entities/hr/hr-structure/hr-structure.vue');
const DepartmentComponent = () => import('@/entities/hr/department/department.vue');
const PositionComponent = () => import('@/entities/hr/position/position.vue');
const JobComponent = () => import('@/entities/hr/job/job.vue');
const EmployeeComponent = () => import('@/entities/hr/employee/employee.vue');
const BranchComponent = () => import('@/entities/hr/branch/branch.vue');
const LevelStateComponent = () => import('@/entities/hr/level-state/level-state.vue');
const DistrictComponent = () => import('@/entities/hr/district/district.vue');
const DocLetterComponent = () => import('@/entities/chancellery/registration/doc-letter/doc-letter.vue');
const DocLetterFormComponent = () => import('@/entities/chancellery/registration/doc-letter-form/doc-letter-form.vue');
const DocInternalRegistrationComponent = () =>
  import('@/entities/chancellery/registration/doc-internal-registration/doc-internal-registration.vue');
const DocAppealTabComponent = () => import('@/entities/chancellery/registration/doc-appeal/appeal-tab.vue');
const RefDocTypeComponent = () => import('@/entities/doc/ref-doc-type/ref-doc-type.vue');
const RefDocOrganizationComponent = () => import('@/entities/doc/ref-doc-organization/ref-doc-organization.vue');
const TaskPurposeComponent = () => import('@/entities/resolution/task-purpose/task-purpose.vue');
const TaskTypeComponent = () => import('@/entities/resolution/task-type/task-type.vue');
const ReceivedAnswerTypeComponent = () => import('@/entities/resolution/received-answer-type/received-answer-type.vue');
const RefDocClassificationComponent = () => import('@/entities/doc/ref-doc-classification/ref-doc-classification.vue');
const RefDocClassificationTypeComponent = () => import('@/entities/doc/ref-doc-classification-type/ref-doc-classification-type.vue');
const RefDocCountryComponent = () => import('@/entities/doc/ref-doc-country/ref-doc-country.vue');
const DocJuridicalComponent = () => import('@/entities/doc/doc-juridical/doc-juridical.vue');
const RefDocAppealerComponent = () => import('@/entities/doc/ref-doc-appealer/ref-doc-appealer.vue');
const RefDocDuplicateComponent = () => import('@/entities/doc/ref-doc-duplicate/ref-doc-duplicate.vue');
const DocJournalComponent = () => import('@/entities/doc/doc-journal/doc-journal.vue');
const DocJournalUserComponent = () => import('@/entities/doc/doc-journal-user/doc-journal.vue');
// const RefBreakingLawComponent = () => import("@/entities/presentation/ref-breaking-law/ref-breaking-law.vue");
const DocPriorityComponent = () => import('@/entities/doc/doc-priority/doc-priority.vue');
// const RefArticlePanelComponent = () => import("@/entities/presentation/ref-article-panel/ref-article-panel.vue");
const DocSourceFormComponent = () => import('@/entities/doc/doc-source-form/doc-source-form.vue');
const DocSourceFormCategoryComponent = () => import('@/entities/doc/doc-source-form-category/doc-source-form-category.vue');
const DocReceptionComponent = () => import('@/entities/doc/doc-reception/doc-reception.vue');
const MovementRuleComponent = () => import('@/entities/settings/movement-rule/movement-rule.vue');
const MovementRuleFieldComponent = () => import('@/entities/settings/ref/movement-rule-field/movement-rule-field.vue');
const MovementRuleFieldCategoriesComponent = () =>
  import('@/entities/settings/ref/movement-rule-field-categories/movement-rule-field-categories.vue');
const MovementRuleTypeCategoriesComponent = () =>
  import('@/entities/settings/ref/movement-rule-type-categories/movement-rule-type-categories.vue');
const MovementRuleTypeComponent = () => import('@/entities/settings/ref/movement-rule-type/movement-rule-type.vue');
// const CooperationComponent = () => import("@/entities/pres/cooperation/cooperation.vue");
// const SignedDocComponent = () => import("@/entities/pres/signed-doc/signed-doc.vue");
// const NoticeComponent = () => import("@/entities/pres/notice/notice.vue");
const IncomeComponent = () => import('@/entities/income/income.vue');
const ChatDiscussionComponent = () => import('@/entities/income/chat-discussion/chat-discussion.vue');
const OutgoingComponent = () => import('@/entities/outgoing/outgoing.vue');
// const RefAppealTypeComponent = () => import("@/entities/presentation/ref-appeal-type/ref-appeal-type.vue");
// const RefDecisionMadeTypeComponent = () => import("@/entities/presentation/ref-decision-made-type/ref-decision-made-type.vue");
const DocInternalComponent = () => import('@/entities/my-document/doc-internal/doc-internal.vue');
const DocOutComponent = () => import('@/entities/my-document/doc-out/doc-out.vue');
const DocNoticeComponent = () => import('@/entities/my-document/doc-notice/doc-notice.vue');
const MicrocreditContractComponent = () => import('@/entities/contract/microcredit-contract/microcredit-contract.vue');
const RoleComponent = () => import('@/entities/role/role.vue');
const JobRoleComponent = () => import('@/entities/role-panel/job-role.vue');
const BranchTaskTabComponent = () => import('@/entities/chancellery/branch-task/branch-task-tab.vue');
const DocOutsideComponent = () => import('@/entities/doc/doc-outside/doc-outside.vue');
const AllDocsComponent = () => import('@/entities/chancellery/all-docs/all-docs.vue');
const ManageExecuteComponent = () => import('@/entities/control/execute-control/manage-execute.vue');
const ReceivedControlTabComponent = () => import('@/entities/control/received-control/received-control-tab.vue');
// const BranchControlTabComponent = () => import("@/entities/branch-control/branch-control-tab.vue");
const AppealControlTabComponent = () => import('@/entities/control/appeal-control/appeal-control-tab.vue');
const SubBranchTabComponent = () => import('@/entities/control/sub-branch/sub-branch-tab.vue');
const TemplateFolderComponent = () => import('@/entities/ref/folder/template-folder.vue');
const ContactComponent = () => import('@/entities/utils/contact/contact.vue');
const ControlsDownload = () => import('@/entities/controls-download/controls-download.vue');
const DownloadExcelProgress = () => import('@/entities/reports/download-excel-progress/download-excel-progress.vue');
const AnnouncementComponent = () => import('@/entities/app-announcement/app-announcement.vue');
const GeneralReferenceComponent = () => import('@/entities/ref/general-reference/general-reference.vue');
const TaskContentComponent = () => import('@/entities/resolution/task-content/task-content.vue');
const HelperTabComponent = () => import('@/entities/chancellery/helper/helper-tab.vue');
const InactiveTabComponent = () => import('@/entities/inactive/inactive-tab.vue');
const Reports = () => import('@/entities/reports/reports.vue');
const DocReports = () => import('@/entities/reports/report-forms/doc-reports.vue');
const AppealReport = () => import('@/entities/reports/appeal/appeal-report.vue');
const AppealReport1 = () => import('@/entities/reports/appeal/report-1/appeal-report-1.vue');
const AppealReport2 = () => import('@/entities/reports/appeal/report-2/appeal-report-2.vue');
const AppealReport3 = () => import('@/entities/reports/appeal/report-3/appeal-report-3.vue');
const AppealReport4 = () => import('@/entities/reports/appeal/report-4/appeal-report-4.vue');
const AppealReport5 = () => import('@/entities/reports/appeal/report-5/appeal-report-5.vue');
// const Goal = () => import('@/entities/kpi/goal/goal.vue');
// const Direction = () => import('@/entities/kpi/direction/direction.vue');
// const KpiTask = () => import('@/entities/kpi/task/kpi-task.vue');
// const Measure = () => import('@/entities/kpi/measure/measure.vue');
// const ActionEvent = () => import('@/entities/kpi/action-event/action-event.vue');
// const TaskAnswer = () => import('@/entities/kpi/task-answer/task-answer.vue');
// const MyTask = () => import('@/entities/kpi/my-task/my-task.vue');
// const TaskAnswerAgree = () => import('@/entities/kpi/task/income/task-agree/task-agree.vue');
// const TaskAnswerAgreeOutcome = () => import('@/entities/kpi/task/outcome/task-agree/task-agree.vue');
// const TaskAnswerIncoming = () => import('@/entities/kpi/task/income/task-incoming/task-incoming.vue');
// const TaskApprove = () => import('@/entities/kpi/task/income/task-approve/task-approve.vue');
// const TaskOutComeApprove = () => import('@/entities/kpi/task/outcome/task-approve/task-approve.vue');
const RefAreaComponent = () => import('@/entities/hr/ref-area/ref-area.vue');
const VideoTutorialPlayerComponent = () => import('@/entities/video-tutorial/video-tutorial-player/video-tutorial-player.vue');
const VideoTutorialComponent = () => import('@/entities/video-tutorial/video-tutorial.vue');
const EmployeeCalendar = () => import('@/entities/reports/employee-calendar/employee-calendar.vue');
Vue.use(Router);

// prettier-ignore
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "MainLayout",
      component: MainLayout,
      children: [
        {
          path: "/task-content",
          name: "TaskContentComponent",
          component: TaskContentComponent
        },


        {
          path: "/all-docs",
          name: "AllDocsComponent",
          component: AllDocsComponent
        },
        {
          path: "/branch-task-tab/:tabName",
          name: "BranchTaskTabComponent",
          component: BranchTaskTabComponent
        },
        {
          path: "/doc-outside",
          name: "DocOutsideComponent",
          component: DocOutsideComponent
        },
        {
          path: "/manage-execute",
          name: "ManageExecuteComponent",
          component: ManageExecuteComponent
        },
        {
          path: "/received-control-tab/:tabName",
          name: "ReceivedControlTabComponent",
          component: ReceivedControlTabComponent
        },
        {
          path: "/appeal-control-tab/:tabName",
          name: "AppealControlTabComponent",
          component: AppealControlTabComponent
        },
        {
          path: "/sub-branch-tab/:tabName",
          name: "SubBranchTabComponent",
          component: SubBranchTabComponent
        },
        {
          path: "/job-role",
          name: "JobRoleComponent",
          component: JobRoleComponent
        },
        {
          path: "/role",
          name: "RoleComponent",
          component: RoleComponent
        },
        {
          path: "/received-answer-type",
          name: "ReceivedAnswerTypeComponent",
          component: ReceivedAnswerTypeComponent
        },
        {
          path: "/task-type",
          name: "TaskTypeComponent",
          component: TaskTypeComponent
        },
        {
          path: "/",
          name: "Home",
          component: Home
        },
        {
          path: "/task-purpose",
          name: "TaskPurposeComponent",
          component: TaskPurposeComponent
        },
        {
          path: "/doc-journal",
          name: "DocJournalComponent",
          component: DocJournalComponent
        },
        {
          path: "/doc-journal-user",
          name: "DocJournalComponent",
          component: DocJournalUserComponent
        },
        // {
        //   path: "/number-reservation",
        //   name: "NumberReservationComponent",
        //   component: NumberReservationComponent
        // },

        {
          path: "/doc-juridical",
          name: "DocJuridicalComponent",
          component: DocJuridicalComponent
        },
        {
          path: "/doc-appeal-tab/:tabName",
          name: "DocAppealTabComponent",
          component: DocAppealTabComponent
        },
        {
          path: "/helper-tab/:tabName",
          name: "HelperTabComponent",
          component: HelperTabComponent
        },
        {
          path: "/inactive-tab/:tabName",
          name: "InactiveTabComponent",
          component: InactiveTabComponent
        },
        {
          path: "/doc-priority",
          name: "DocPriorityComponent",
          component: DocPriorityComponent
        },
        {
          path: "/doc-source-form",
          name: "DocSourceFormComponent",
          component: DocSourceFormComponent
        },
        {
          path: "/doc-source-form-category",
          name: "DocSourceFormCategoryComponent",
          component: DocSourceFormCategoryComponent
        },
        {
          path: "/doc-reception",
          name: "DocReceptionComponent",
          component: DocReceptionComponent
        },
        {
          path: "/region",
          name: "RegionComponent",
          component: RegionComponent
        },
        {
          path: "/finder",
          name: "FinderArchitecture",
          component: FinderArchitecture
        },
        {
          path: "/hr-structure",
          // meta: {authorities: [Authority.USER]},
          name: "HrStructureComponent",
          component: HrStructureComponent
        },
        {
          path: "/department",
          name: "DepartmentComponent",
          component: DepartmentComponent
        },
        {
          path: "/position",
          name: "PositionComponent",
          component: PositionComponent
        },
        {
          path: "/job",
          name: "JobComponent",
          component: JobComponent
        },
        {
          path: "/employee",
          name: "EmployeeComponent",
          component: EmployeeComponent
        },
        {
          path: "/branch",
          name: "BranchComponent",
          component: BranchComponent
        },
        {
          path: "/level-state",
          name: "LevelStateComponent",
          component: LevelStateComponent
        },
        {
          path: "/district",
          name: "DistrictComponent",
          component: DistrictComponent
        },
        {
          path: "/ref-area",
          name: "RefAreaComponent",
          component: RefAreaComponent
        },
        {
          path: "/doc-letter",
          name: "DocLetterComponent",
          component: DocLetterComponent
        },
        {
          path: "/doc-letter-form",
          name: "DocLetterFormComponent",
          component: DocLetterFormComponent
        },
        {
          path: "/doc-internal-registration",
          name: "DocInternalRegistrationComponent",
          component: DocInternalRegistrationComponent
        },
        {
          path: "/doc-type",
          name: "RefDocTypeComponent",
          component: RefDocTypeComponent
        },
        {
          path: "/sent-organization",
          name: "RefDocOrganizationComponent",
          component: RefDocOrganizationComponent
        },
        {
          path: "/doc-classification",
          name: "RefDocClassificationComponent",
          component: RefDocClassificationComponent
        },
        {
          path: "/doc-classification-type",
          name: "RefDocClassificationTypeComponent",
          component: RefDocClassificationTypeComponent
        },
        {
          path: "/country",
          name: "RefDocCountryComponent",
          component: RefDocCountryComponent
        },
        {
          path: "/appealer",
          name: "RefDocAppealerComponent",
          component: RefDocAppealerComponent
        },
        {
          path: "/doc-duplicate",
          name: "RefDocDuplicateComponent",
          component: RefDocDuplicateComponent
        },
        {
          path: "/movement-rule",
          name: "MovementRuleComponent",
          component: MovementRuleComponent
        },
        {
          path: "/movement-rule-field-category",
          name: "MovementRuleFieldCategoriesComponent",
          component: MovementRuleFieldCategoriesComponent
        },
        {
          path: "/movement-rule-field",
          name: "MovementRuleFieldComponent",
          component: MovementRuleFieldComponent
        },
        {
          path: "/movement-rule-type-category",
          name: "MovementRuleTypeCategoriesComponent",
          component: MovementRuleTypeCategoriesComponent
        },
        {
          path: "/movement-rule-type",
          name: "MovementRuleTypeComponent",
          component: MovementRuleTypeComponent
        },
        {
          path: "/reports",
          name: "Reports",
          component: Reports,
          children: [
            {
              path: "appeal",
              name: "AppealReport",
              component: AppealReport,
              children: [
                {
                  path: "report-1",
                  name: "AppealReport1",
                  component: AppealReport1
                },
                {
                  path: "report-2",
                  name: "AppealReport2",
                  component: AppealReport2
                },
                {
                  path: "report-3",
                  name: "AppealReport3",
                  component: AppealReport3
                },
                {
                  path: "report-4",
                  name: "AppealReport4",
                  component: AppealReport4
                },
                {
                  path: "report-5",
                  name: "AppealReport5",
                  component: AppealReport5
                }
              ]
            },
            {
              path: "controls-download",
              name: "ControlsDownload",
              component: ControlsDownload
            },
            {
              path: "download-excel-progress",
              name: "downloadExcelProgress",
              component: DownloadExcelProgress
            }
          ]
        },
        {
          path: "/reports/docs/:tabName",
          name: "DocReports",
          component: DocReports
        },
        {
          path: "/income/:tabName",
          name: "IncomeComponent",
          component: IncomeComponent
        },
        {
          path: "/discussion/:tabName",
          name: "ChatDiscussionComponent",
          component: ChatDiscussionComponent
        },
        {
          path: "/outgoing/:tabName",
          name: "OutgoingComponent",
          component: OutgoingComponent
        },
        {
          path: "/doc-internal",
          name: "DocInternalComponent",
          component: DocInternalComponent
        },
        {
          path: "/doc-out",
          name: "DocOutComponent",
          component: DocOutComponent
        },
        {
          path: "/doc-notice",
          name: "DocNoticeComponent",
          component: DocNoticeComponent
        },
        {
          path: "/microcredit-contract",
          name: "MicrocreditContractComponent",
          component: MicrocreditContractComponent
        },
        {
          path: "/template-folder",
          name: "TemplateFolderComponent",
          component: TemplateFolderComponent
        },
        {
          path: "/contact",
          name: "ContactComponent",
          component: ContactComponent
        },
        {
          path: "/announcement",
          name: "AnnouncementComponent",
          component: AnnouncementComponent
        },
        {
          path: "/video-tutorial-player",
          name: "VideoTutorialPlayerComponent",
          component: VideoTutorialPlayerComponent
        },
        {
          path: "/video-tutorial",
          name: "VideoTutorialComponent",
          component: VideoTutorialComponent
        },
        {
          path: "/general-reference",
          name: "GeneralReference",
          component: GeneralReferenceComponent
        },

        {
          path: "/employee-calendar",
          name: "EmployeeCalendar",
          component: EmployeeCalendar
        },
        // {
        //   path: "/kpi/direction",
        //   name: "Direction",
        //   component: Direction
        // },
        // {
        //   path: "/kpi/task",
        //   name: "KpiTask",
        //   component: KpiTask
        // },
        // {
        //   path: "/kpi/goal",
        //   name: "Goal",
        //   component: Goal
        // },
        // {
        //   path: "/kpi/measure",
        //   name: "Measure",
        //   component: Measure
        // },
        // {
        //   path: "/kpi/action-event",
        //   name: "ActionEvent",
        //   component: ActionEvent
        // },
        // {
        //   path: "/kpi/task-answer",
        //   name: "TaskAnswer",
        //   component: TaskAnswer
        // },
        // {
        //   path: "/kpi/my-task",
        //   name: "MyTask",
        //   component: MyTask
        // },
        // {
        //   path: "/kpi/task-agree",
        //   name: "TaskAnswerAgree",
        //   component: TaskAnswerAgree
        // },
        // {
        //   path: "/kpi/outcome/task-agree",
        //   name: "TaskAnswerOutAgree",
        //   component: TaskAnswerAgreeOutcome
        // },
        // {
        //   path: "/kpi/task-incoming",
        //   name: "TaskAnswerAgree",
        //   component: TaskAnswerIncoming
        // },
        //
        // {
        //   path: "/kpi/task-approve",
        //   name: "TaskApprove",
        //   component: TaskApprove
        // },
        // {
        //   path: "/kpi/outcome/task-approve",
        //   name: "TaskOutComeApprove",
        //   component: TaskOutComeApprove
        // }
      ]
    },
    {
      path: "/forbidden",
      name: "Forbidden",
      component: Error,
      meta: { error403: true }
    },
    {
      path: "/login",
      name: "LoadingLoginPage",
      component: LoadingLoginPage
    },
    {
      path: "/not-found",
      name: "NotFound",
      component: Error,
      meta: { error404: true }
    },
    ...admin,
    entities,
    ...pages
  ]
});

export default router;
